import React from 'react';
import './intro.css';

const Intro = () => {
  return (
    <section id="intro">
      
        <div className="introContent">
          <p className="introP">
            Hi there! I'm Alexis, a full stack engineer fueled by a love for
            continuous learning. Right now, I'm immersing myself in the realms
            of AI and machine learning.
          </p>
          <button className='introBtn'>
            <a className='introA' href="mailto:alexis.gonzalez.390@gmail.com">
              Let's connect
            </a>
          </button>
        
      </div>

      <div className="vector">
      <div className="white">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 180 180"
    fill="none"
  >
    <circle cx="90" cy="90" r="88" stroke="#E0DDD6" stroke-width="4" />
  </svg>
</div>

        <div className="green">
        <svg xmlns="http://www.w3.org/2000/svg"viewBox="0 0 592 264" fill="none" className='svgGreen'>
  <path d="M578.652 259.829C530.069 279.572 513.45 222.814 459.093 222.814C404.736 222.814 404.736 261.908 350.357 261.908C295.978 261.908 296 222.814 241.621 222.814C187.242 222.814 187.264 261.908 132.885 261.908C78.506 261.908 83.5553 244.583 34.972 224.893C10.6036 214.995 0 220.291 0 198.238C0 176.185 48.2979 176.168 48.2979 154.097C48.2979 132.027 0 132.027 0 109.938C0 87.8502 48.2979 87.8679 48.2979 65.7975C48.2979 43.727 -10.9768 14.0687 13.3258 4.17072C61.9091 -15.5719 78.5279 41.1858 132.885 41.1858C187.242 41.1858 187.264 2.09162 241.621 2.09162C295.978 2.09162 295.978 41.1858 350.357 41.1858C404.736 41.1858 404.736 2.09162 459.093 2.09162C513.45 2.09162 508.423 19.3819 557.028 39.1068C581.396 49.0047 592 43.7092 592 65.7619C592 87.8146 543.702 87.8324 543.702 109.903C543.702 131.973 592 131.991 592 154.062C592 176.132 536.94 182.618 544.69 203.818C556.479 235.928 603.043 249.914 578.652 259.829Z" fill="#CADD57"/>
</svg>
       
        </div>
      
      </div>
    </section>
  );
};

export default Intro;
